import { render } from "./TradesSummaryWidget.vue?vue&type=template&id=3e546d0e&scoped=true&ts=true"
import script from "./TradesSummaryWidget.vue?vue&type=script&lang=ts"
export * from "./TradesSummaryWidget.vue?vue&type=script&lang=ts"

import "./TradesSummaryWidget.vue?vue&type=style&index=0&id=3e546d0e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e546d0e"]])

export default __exports__